import { getLocale } from "../runtime";

const sv_searchresultsone = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Visa ett resultat`
};

const searchresultsone = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchresultsone(inputs)
	return "searchResultsOne";
};

export { searchresultsone as "searchResultsOne" };